module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "sidebar sidebar-active",
    attrs: {
      "id": "sidebar"
    }
  }, [_c('div', {
    staticClass: "sidebar-inner"
  }, [_c('section', {
    staticClass: "site-overview"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "liner-split"
  }), _vm._v(" "), _c('nav', {
    staticClass: "menu",
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-home"
  }), _vm._v(" 首页")])], 1), _vm._v(" "), _c('div', {
    staticClass: "liner-split"
  }), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/music"
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-music"
  }), _vm._v(" 音乐盒")])], 1), _vm._v(" "), _c('div', {
    staticClass: "liner-split"
  }), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/gallery"
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-picture"
  }), _vm._v(" 图库")])], 1), _vm._v(" "), _c('div', {
    staticClass: "liner-split"
  }), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/more"
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-option-horizontal"
  }), _vm._v(" 更多")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-close text-center"
  }, [_c('i', {
    staticClass: "iconfont icon-tubiao06",
    on: {
      "click": _vm.closeMenu
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-author"
  }, [_c('img', {
    staticClass: "site-author-image",
    attrs: {
      "src": require("../assets/img/zard.jpg")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "site-author-name"
  }, [_vm._v("What a beautiful moment...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22b79078"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FrameAside.vue
// module id = 96
// module chunks = 0